import { DocumentoPessoa } from "./documento-pessoa.model";
import { TelefonePessoa } from "./telefone-pessoa.model";
import { EnderecoPessoa } from "./endereco-pessoa.model";

export class Pessoa {

   cpf: number;
   nome: string;
   nascimento: Date;
   codigoNacionalidade: number;
   codigoSexo: number;
   nomeMae: string;
   nomePai: string;
   codigoEstadoCivil: number;
   codigoEscolaridade: number;
   codigoCorRaca: number;
   codigoPaisNascimento: number;
   codigoTipoDeficiencia: number;
   possuiDeficiencia: boolean;
   codigoGrupoSanguineo: number;
   codigoFatorRH: number;
   primeiroEmprego: boolean;
   senha: string;
   codigoCidadeNascimento: number;
   codigoUfNascimento: number;
   codigoTipoResidencia: number;
   email: string;
   possuiPrevidenciaComplementar: boolean;
   endereco: EnderecoPessoa = new EnderecoPessoa();
   documentos: DocumentoPessoa = new DocumentoPessoa();
   telefones: TelefonePessoa[] = [];

   constructor() { }

   CarregarDadosPessoa(pessoaBD: Pessoa) {
      this.cpf = pessoaBD.cpf;
      this.nome = pessoaBD.nome;
      this.nascimento = pessoaBD.nascimento;
      this.codigoNacionalidade = pessoaBD.codigoNacionalidade;
      this.codigoSexo = pessoaBD.codigoSexo;
      this.nomeMae = pessoaBD.nomeMae;
      this.nomePai = pessoaBD.nomePai;
      this.codigoEstadoCivil = pessoaBD.codigoEstadoCivil;
      this.codigoEscolaridade = pessoaBD.codigoEscolaridade;
      this.codigoCorRaca = pessoaBD.codigoCorRaca;
      this.codigoPaisNascimento = pessoaBD.codigoPaisNascimento;
      this.possuiDeficiencia = pessoaBD.possuiDeficiencia;
     
      if (pessoaBD.possuiDeficiencia) {
         this.codigoTipoDeficiencia = pessoaBD.codigoTipoDeficiencia;   
      }else{
         this.codigoTipoDeficiencia = 0;
      }      
      
      this.codigoGrupoSanguineo = pessoaBD.codigoGrupoSanguineo;
      this.codigoFatorRH = pessoaBD.codigoFatorRH;
      this.primeiroEmprego = pessoaBD.primeiroEmprego;
      this.codigoCidadeNascimento = pessoaBD.codigoCidadeNascimento;
      this.codigoUfNascimento = pessoaBD.codigoUfNascimento;
      this.codigoTipoResidencia = pessoaBD.codigoTipoResidencia;
      this.possuiPrevidenciaComplementar = pessoaBD.possuiPrevidenciaComplementar;
      this.documentos = DocumentoPessoa.CarregarDocumentos(pessoaBD.documentos);
   }
}


// WEBPACK FOOTER //
// ./src/app/models/pessoa.model.ts